import {CSSProperties} from 'react';

import styled, {css} from 'styled-components';

import {DEFAULT_PALETTE, mixins} from '../../styles';
import {EStackDirection, TSpacingSize} from '../../types';

const Column = styled.div`
  ${mixins.column}
`;

const Row = styled.div`
  ${mixins.row}
`;

type TStackProps = {
  direction?: keyof typeof EStackDirection;
  size?: TSpacingSize;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  isWrap?: boolean;
  isFullWidth?: boolean;
};

const Stack = styled.div<TStackProps>`
  ${({direction = EStackDirection.COLUMN, size, align, justify}) =>
    mixins.stack({size, direction, align, justify})}
  ${({isFullWidth}) =>
    isFullWidth &&
    css`
      width: 100%;
    `}
  ${({isWrap}) =>
    isWrap &&
    css`
      flex-wrap: wrap;
    `}
`;

type TDividerProps = {
  color?: keyof typeof DEFAULT_PALETTE;
  height?: string;
};

const Divider = styled.div<TDividerProps>`
  ${({height = '1px'}) => mixins.wh('100%', height)}
  background-color: ${({theme, color = 'grey100'}) => theme.palette[color]};
`;

export {Stack, Column, Row, TStackProps, Divider};
